package com.neurobs.ccabserver.subjectsessionview.components.sessionrunview.components

import com.neurobs.react.ReactElementFactory
import com.neurobs.react.semanticui.UiAccordionFactory
import slinky.core.FunctionalComponent
import slinky.core.annotations.react

import scala.scalajs.js

@react
object CommentsAccordion {
  case class Props(comments: List[String])
  val component = FunctionalComponent[Props] { props =>

    def pStyle = Seq[(String, js.Any)](("fontSize", "11px"))
    def CommentContentElement(comment: String) = ReactElementFactory.P(comment)(pStyle)

    if (props.comments.isEmpty) null
    else {
      UiAccordionFactory.Accordion(
        UiAccordionFactory.DropdownTitle("Examiner comments"),
        UiAccordionFactory.Content(
          props.comments.map(CommentContentElement(_))
        )
      )
    }

  }
}
